import axios from 'axios'
import { useAuth } from "./authStore"

const domain = process.env.REACT_APP_DOMAIN

const localCfg = {
    baseURL: '/api/',
}

const devCfg = {
    baseURL: 'https://'+domain+'/api/',
}



export const getCfgByOrigin = () => {
    switch (window.location.origin) {
        case "http://localhost:3000": // used in tests
            return localCfg
        case "https://"+domain:
            return devCfg
        default:
            return devCfg
    }
}

class APIClient {

    constructor(cfg) {
        const axiosCfg = {
            baseURL: cfg.baseURL,
            timeout: cfg.timeout || 60000,
        }
        this.axios_ = axios.create(axiosCfg)
    }

    setToken(token) {
        try {
            this.token = token
            this.axios_.defaults.headers.common['authorization'] = 'Bearer ' + token
            return this
        } catch(e) {
            console.error(e)
        }
    }

    async loadProxies(page=0, limit=10, country, ip=null, state=null, zip=null, city=null, isp=null, conn=null) {
        try {
            const params = {
                cc: country,
                cursor: page*limit,
                limit: limit,
                segments: true,
            }
            // console.log('CONN : '+conn)
            // console.log('state : '+state)
            if(ip!==null && ip.trim() !== ''){
                // Разделяем IP на октеты (только первые два, так как остальные скрыты в таблице)
                const ipParts = ip.split('.')
                if(ipParts[0]) {
                    params['ip1'] = ipParts[0]
                }
                if(ipParts[1]) {
                    params['ip2'] = ipParts[1]
                }
            }

            if(state!==null){
                params['reg'] = state
            }
            if(zip!==null)params['zip'] = zip
            if(city!==null)params['city'] = city
            if(isp!==null)params['isp'] = isp
            if(conn!=='')params['conn'] = conn
            
            // Логирование только в development режиме
            if (process.env.NODE_ENV === 'development') {
                console.log('API call params:', params)
                console.log('IP filter details:', {
                    ip: ip,
                    ip1: params.ip1,
                    ip2: params.ip2,
                    hasIpFilter: ip !== null && ip.trim() !== ''
                })
            }
            const proxiesList = await this.__call('/agents', 'GET', params)
            if (process.env.NODE_ENV === 'development') {
                console.log('API response:', proxiesList)
            }

            return proxiesList
        } catch (e) {
            console.error(e)
        }
    }

    async getUserData(userId, signal=null) {
        try {
            const userData = await this.__call('/accounts/my', 'GET', null, null, signal)
  
            return userData
        } catch (e) {
            // Игнорируем ошибки отмены запросов
            if (e.name === 'AbortError' || e.code === 'ECONNABORTED' || e.name === 'CanceledError' || e.code === 'ERR_CANCELED' || e.message?.includes('NS_BINDING_ABORTED')) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('getUserData request aborted')
                }
                return undefined
            }
            console.error('ERROR')
            console.error(e)
        }
    }

    async buyProxy(proxyData) {
        try {
            const response = await this.__call('/leases', 'POST', {}, proxyData)
            
            return response
        } catch (e) {
            console.error('ERROR')
            console.error(e)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            throw e
        }
    }

    async getAgentInfo(id) {
        try {
            const response = await this.__call('/agents/'+id, 'GET',{})
            
            return response
        } catch (e) {
            console.error('ERROR')
            console.error(e)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            throw e
        }
    }

    async getUserHistory(startDate, endDate, page, rowsPerPage) {
        try {
            const params = {
                offset: page*rowsPerPage,
                limit: rowsPerPage,
                start: startDate,
                end: endDate,
            }
            const historyData = await this.__call('/leaseHistory', 'GET', params)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            return historyData
        } catch (e) {
            console.error(e)

            throw e
        }
    }

    async saveProxyWhitelist(id, whitelist) {
        try {
            const body = {
                whitelist: whitelist
            }
            const response = await this.__call('/authport/create/'+id, 'POST', {}, body)
            // console.log(response)
            
            return response
        } catch (e) {
            console.error(e)

            throw e
        }
    }

    async renewProxy(id) {
        try {
            
            const response = await this.__call('/leases/'+id, 'PATCH')
            // console.log(response)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            return response
        } catch (e) {
            console.error(e)

            throw e
        }
    }

    async getUserPayments(startDate, endDate, page, rowsPerPage) {
        try {
            const params = {
                offset: page*rowsPerPage,
                limit: rowsPerPage,
                start: startDate,
                end: endDate,
            }

            const paymentsData = await this.__call('/txrecords/', 'GET', params)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            return paymentsData
        } catch (e) {
            console.error(e)
        }
    }

    async createRefundTicket(id, reason) {
        try {
            const body = {
                leaseID: id,
                reason: reason
            }
            // console.log(body)
            const response = await this.__callTicket('/tickets/', 'POST', {}, body)
            
            return response
        } catch (e) {
            console.error(e)
            throw e
        }
    }

    async getUserTickets(startDate, endDate, page, rowsPerPage) {
        try {
            const params = {
                offset: page*rowsPerPage,
                limit: rowsPerPage,
                start: startDate,
                end: endDate,
            }

            const ticketsData = await this.__call('/tickets/', 'GET', params)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            return ticketsData
        } catch (e) {
            console.error(e)
        }
    }

    async checkProxySpeed(id) {
        try {
            const resultData = await this.__call('/agents/'+id+'/speedcheck/', 'GET',)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            // const resultData = {
            //     "speed": 25553285,
            //     "checkTime": "2024-08-21T19:09:15.225Z"
            // }

            return resultData
        } catch (e) {
            console.error('checkProxySpeed error:', e)
            throw e // Пробрасываем ошибку дальше
        }
    }



    async getCountries() {
        try {
            const params = {
                all: true,
            }

            const countryData = await this.__call('/totals/agents', 'GET', params)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)
            
            return countryData
        } catch (e) {
            console.error(e)
        }
    }

    async loacActiveProxies(signal=null) {
        try {
            const activeList = await this.__call('/leases', 'GET', null, null, signal)
            // console.log('API response:', activeList)
            
            return activeList
        } catch (e) {
            // Игнорируем ошибки отмены запросов
            if (e.name === 'AbortError' || e.code === 'ECONNABORTED' || e.name === 'CanceledError' || e.code === 'ERR_CANCELED' || e.message?.includes('NS_BINDING_ABORTED')) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('loacActiveProxies request aborted')
                }
                return undefined
            }
            console.error(e)
        }
    }

    async changeUserPassword(userId, newPassword) {
        try {
            const body = {
                password: newPassword,
            }

            const result = await this.__call('/accounts/'+userId, 'PATCH', {}, body)
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            console.error(e)
        }
    }

    async getUserInfo(id) {
        try {
            const result = await this.__call('/accounts/'+id, 'GET', {})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
           throw e
        }
    }

    async getLeaseInfo(id) {
        try {
            const result = await this.__call('/leases/'+id, 'GET', {})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async refundLeaseAdmin(id) {
        try {
            const result = await this.__call('/leases/'+id, 'DELETE', {})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async addUserBalance(userId, balanceC) {
        try {
            const result = await this.__call('/accounts/'+userId, 'PATCH', {}, {balanceDeltaC: parseInt(balanceC)})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async changeUserPasswordAdmin(userId, password) {
        try {
            const result = await this.__call('/accounts/'+userId, 'PATCH', {}, {password: password})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async geticketsAdmin(page, rowsPerPage, status) {
        try {
            const params = {
                offset: page,
                limit: rowsPerPage,
                status: status,
            }

            const ticketsData = await this.__call('/tickets/', 'GET', params)
            
            return ticketsData
        } catch (e) {
            console.error(e)
        }
    }


    async closeTicketdAdmin(ticketId, description, status) {
        try {
            const result = await this.__call('/tickets/', 'PATCH', {}, {id: ticketId, message: description, status: status})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async chargeRequest(currency, amount) {
        try {
            const result = await this.__call('/payment/request', 'POST', {}, {amount: amount})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async updateProxyNote(agentId, note) {
        try {
            const result = await this.__call('/agentnotes/' + agentId, 'PUT', {}, {note: note})
            // console.log('API call params:', params)
            // console.log('API response:', proxiesList)

            return result
        } catch (e) {
            throw e
        }
    }

    async __call(uri, method, params=null, body=null, signal=null) {
        method = method || 'GET'

        try {
            const headers = {
                'authorization': 'Bearer ' + this.token,
            }
            // console.log(params)
            const resp = await this.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
                signal, // Добавляем поддержку AbortController
            })

            return resp.data
        } catch (err) {
            // Игнорируем ошибки отмены запросов - не выбрасываем их
            if (err.name === 'AbortError' || err.code === 'ECONNABORTED' || err.name === 'CanceledError' || err.code === 'ERR_CANCELED' || err.message?.includes('NS_BINDING_ABORTED')) {
                if (process.env.NODE_ENV === 'development') {
                    console.log('Request aborted:', uri)
                }
                return undefined
            }
            // console.log('API ERROR')
            // console.log(err.response)
            return this.handleError_(err)
        }
    }

    async __callTicket(uri, method, params=null, body=null) {
        method = method || 'GET'

        try {
            const headers = {
                'authorization': 'Bearer ' + this.token,
            }
            // console.log(params)
            const resp = await this.axios_.request(uri, {
                method,
                headers,
                params,
                data: body,
            })

            return resp.data
        } catch (err) {
            // console.log('TICKET API ERROR')
            // console.log(err.response)
            return this.handleTicketError_(err)
        }
    }

    authNeed() {
        localStorage.removeItem('token', null)
        window.location.href = '/login'
    }

    handleError_(err) {
        console.log(err)
        if (err.response) {
            switch (err.response.status) {
                case 401:
                   return this.authNeed()
                case 502:
                    return Promise.reject(new Error('got a 502'))
                default:
                    return Promise.reject(err)
            }
        } else if (err.request) {
            return Promise.reject(err)
        }
    }

    handleTicketError_(err) {
        console.log('Ticket error:', err)
        if (err.response) {
            switch (err.response.status) {
                case 401:
                    // Для тикетов не разлогиниваем, а возвращаем ошибку
                    return Promise.reject(err)
                case 502:
                    return Promise.reject(new Error('got a 502'))
                default:
                    return Promise.reject(err)
            }
        } else if (err.request) {
            return Promise.reject(err)
        }
    }
}

export default APIClient